export default {
  stylePrefix: 'mdl-',

  title: '',

  content: '',

  backdrop: true,

  /**
   * Extend ModalView object (view/ModalView.js)
   * @example
   * extend: {
   *   template() {
   *     return '<div>...New modal template...</div>';
   *   },
   * },
   */
  extend: {}
};
